// removed by extract-text-webpack-plugin
module.exports = {"LoginBox":"_1v6EXWhfssOjfBl9k9p7Eq","LoginBox__title":"_3zPRuhphMQdGDNho6Co508","LoginBox__form":"_2AHC2G0no3enTlwzOeKBte","LoginBox__form-input":"_1xauUJJRdPjvWCGalKVHC-","LoginBox__signin-button":"_2zg45_HlMTpcpU-5E0OdEv","LoginBox__error":"_45S2s83sIexPjo4YetFEU","LoginBox__form-error":"_4-XZQq1oZAQL98cqev_ii","LoginBox__forgot-box":"H2TRQi4-v6dJ8jRzQZY0W","LoginBox__forgot-link":"_297PQYIAWNE-39A9ULvff3","loginWithEpicButtonWrap":"D_WaF1CMOSJYCqxa2DZha"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Login/Login.scss
// module id = 2880
// module chunks = 0